/**
 * Модуль определяет перемещение к определенной области на странице при нажатии на элемент
 *
 * Модуль работает с элементами с классом "move-to",
 * перемещение происходит к области, соответствующей селектору, указанному в атрибуте "data-move-to" элемента,
 * обрабатывается первый элемент из коллекции, соответствующей указанному селектору.
 *
 * В данном примере модуль определит перемещение к надписи "Раздел" при нажатии на кнопку "Переместиться":
 *
 * <input class="move-to" data-move-to="#anchor" type="button" value="Переместиться">
 * <div>
 *     <span id="anchor">Раздел</span>
 * </div>
 */
$(document).ready(function () {
    $('.move-to').on('click', function () {
        var moveToSelector = $(this).data('moveTo'),
            moveToElement;
        if (moveToSelector && (moveToElement = $(moveToSelector).first()[0])) {
            moveToElement.scrollIntoView();
        }
    });
});



// WEBPACK FOOTER //
// ./assets/javascript/move-to.js